import {React , useEffect, useState} from 'react'
import { Button, ButtonGroup } from "@chakra-ui/react";
import "./AdminLandingPage.css";
import AddSubEvent from '../../../components/Admin/Modals/SubEvents/AddSubEvent/AddSubEvent';
import UpdateSubEvent from '../../../components/Admin/Modals/SubEvents/UpdateSubEvent/UpdateSubEvent';
import DeleteSubEvent from '../../../components/Admin/Modals/SubEvents/DeleteSubEvent/DeleteSubEvent';
import BlockUsers from '../../../components/Admin/Modals/Users/BlockUsers/BlockUsers';
import { getAllImages } from '../../../services/Api';

const AdminLandingPage = () => { 
    
    const [images , setImages] = useState();
    useEffect(() => {
        const getImages = async () => {
            const data = await getAllImages();
            console.log(data);
        }
        getImages();
    }, [])
    
    
    const handleAddEvents = () => {
        console.log("Event adding");
    }
    
    const handleUpdateEvents = () => {
        console.log("Event Updating");
    }
    
    const handleDeleteEvents = () => {
        console.log("Event Deleting");
    }
        
  return (
    <div className="admin-landing-page-container">
      <div className="options events">
        <div className="heading">Manage Events</div>
        <div className="buttons">
            <AddSubEvent />
            <DeleteSubEvent />
            {/* <UpdateSubEvent /> */}
        </div>
      </div>
      <div className="options users">
        <div className="heading">Manage Users</div>
            <BlockUsers />
      </div>
    </div>
  );
}

export default AdminLandingPage
